export default __webpack_public_path__ + "static/media/2627 knife block B side.8d1830a5.png";